import React, {useMemo} from 'react';
import type {Alignment, EnrichedAstNode} from 'rendition-core/types';
import AlignStart from 'Icons/AlignStart';
import AlignCenter from 'Icons/AlignCenter';
import AlignEnd from 'Icons/AlignEnd';
//import AlignStretch from 'Icons/AlignStretch';
import TabbedButtonToggle, {type Item} from 'Components/Tailwind/TabbedButtonToggle';
import {useSelectedParentNode} from 'Hooks/AstHooks/useSelectedParentNode';
import {useViewContext} from 'Contexts/ViewContext';
import {EditorSectionTitle} from 'Components/Editing/EditingTitle';
import {segmentedControlClassNames} from '../EditControls';

const setAlignment = (node: EnrichedAstNode, value: Alignment, parentFlexDirection: 'column' | 'row') => {
    node.inputLayoutAbstraction.alignSelf = value;

    if (parentFlexDirection === 'column') {
        if (!node.inputLayoutAbstraction.userMarginSet?.marginLeft) {
            node.position.marginLeft = 0;
        }
        if (!node.inputLayoutAbstraction.userMarginSet?.marginRight) {
            node.position.marginRight = 0;
        }
    } else {
        if (!node.inputLayoutAbstraction.userMarginSet?.marginBottom) {
            node.position.marginBottom = 0;
        }
        if (!node.inputLayoutAbstraction.userMarginSet?.marginTop) {
            node.position.marginTop = 0;
        }
    }
};

export const AlignSelfToggle = () => {
    const {selectedNode, updateSelectedNodes} = useViewContext();
    const {parentNode} = useSelectedParentNode();
    const hasAbsPositionedNode = selectedNode?.calculatedLayoutAbstraction.absolutePosition === false;

    const transform =
        parentNode?.calculatedLayoutAbstraction.flexDirection === 'column' ? 'rotate(-90deg)' : 'rotate(0deg)';

    const AlignOptions = useMemo<Item<Alignment>[]>(
        () => [
            {
                icon: <AlignStart width={13} height={13} style={{transform}} />,
                value: 'flex-start',
            },
            {
                icon: <AlignCenter width={13} height={13} style={{transform}} />,
                value: 'center',
            },
            {
                icon: <AlignEnd width={13} height={13} style={{transform}} />,
                value: 'flex-end',
            },
            // {
            //     icon: <AlignStretch width={17} height={13} style={{transform: stretchTransform}} />,
            //     value: 'stretch',
            // },
        ],
        [transform]
    );

    if (parentNode?.inputLayoutAbstraction.flexDirection === 'Mixed' || !hasAbsPositionedNode) {
        return null;
    }

    return (
        <div className="flex items-center justify-between">
            <EditorSectionTitle title="Align Self" />
            <TabbedButtonToggle
                classNames={segmentedControlClassNames}
                value={
                    selectedNode?.calculatedLayoutAbstraction.alignSelf === 'Mixed'
                        ? undefined
                        : selectedNode?.calculatedLayoutAbstraction.alignSelf
                }
                items={AlignOptions}
                onClick={(value) =>
                    updateSelectedNodes((node) => {
                        setAlignment(
                            node,
                            value,
                            parentNode?.calculatedLayoutAbstraction.flexDirection as 'row' | 'column'
                        );
                    })
                }
            />
        </div>
    );
};
